import { Marketplace } from "../api-client";

// Only the Japanese version of the spec states the 25-char limit, every other locale says 50:
// https://advertising.amazon.com/ja-jp/resources/ad-specs/ecommerce
export const DspHeadlineMaxLength = 50;
export const DspJpHeadlineMaxLength = 25;

export function dspHeadlineLimit(marketplace: Marketplace | undefined): number {
  return marketplace === Marketplace.JP ? DspJpHeadlineMaxLength : DspHeadlineMaxLength;
}
